import { render } from "./GroupCollection.vue?vue&type=template&id=504b3593&scoped=true"
import script from "./GroupCollection.vue?vue&type=script&lang=js"
export * from "./GroupCollection.vue?vue&type=script&lang=js"

import "./GroupCollection.vue?vue&type=style&index=0&id=504b3593&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504b3593"]])

export default __exports__